import React from 'react'
import QuesLink from './QuesLink'

const MostWrong = ({list, clickQuiz}) => {
  return (
    <div className="flex items-center">
      <span className="w-48">Paling Banyak Salah</span>
      <span>: {list.map((item, i) => [i > 0 && ", ", <QuesLink key={i} data={item} clickQuiz={clickQuiz}/>])}</span>
    </div>
  )
}

export default MostWrong